import gql from "graphql-tag";
const field = `
id
numberOrder
name
description


createdAt
updatedAt
`;

const createAppInPlatformGroup = gql`
  mutation(
    $numberOrder: Float
    $name: String!
    $description: String
  ) {
    createAppInPlatformGroup(
      data: {
        numberOrder: $numberOrder
        name: $name
        description: $description
      }
    ) {
      ${field}
    }
  }
`;

const updateAppInPlatformGroup = gql`
  mutation(
    $id: ID!
    $numberOrder: Float
    $name: String!
    $description: String
  ) {
    updateAppInPlatformGroup(
      id: $id
      data: {
        numberOrder: $numberOrder
        name: $name
        description: $description
      }
    ) {
      ${field}
    }
  }
`;

const deleteAppInPlatformGroup = gql`
  mutation($id: ID!) {
    deleteAppInPlatformGroup(id: $id) {
      id
    }
  }
`;

const getAllAppInPlatformGroup = gql`
  {
    getAllAppInPlatformGroup {
      ${field}
    }
  }
`;

export default {
  createAppInPlatformGroup,
  updateAppInPlatformGroup,
  deleteAppInPlatformGroup,
  getAllAppInPlatformGroup,
};
